/**
 * Standardized permission denied messages
 * Ensures consistent messaging across the application
 */

export const PERMISSION_MESSAGES = {
  // Service Types / Appointment Types
  SERVICE_TYPES: {
    title: "Service Types Access Restricted",
    message: "You don't have permission to manage service types. Only managers and owners can access this feature."
  },

  // Team Members / Staff Management
  TEAM_MEMBERS: {
    title: "Team Management Access Restricted", 
    message: "You don't have permission to manage team members. Only managers and owners can access this feature."
  },

  // Business Profile
  BUSINESS_PROFILE: {
    title: "Business Profile Access Restricted",
    message: "You don't have permission to edit the business profile. Only managers and owners can access this feature."
  },

  // Analytics
  ANALYTICS: {
    title: "Analytics Access Restricted",
    message: "You don't have permission to view analytics. Only managers and owners can access this feature."
  },

  // Financials
  FINANCIALS: {
    title: "Financial Access Restricted",
    message: "You don't have permission to view financial information. Only managers and owners can access this feature."
  },

  // Portfolio Management
  PORTFOLIO: {
    title: "Portfolio Access Restricted",
    message: "You don't have permission to manage the portfolio. Only managers and owners can access this feature."
  },

  // Policies
  POLICIES: {
    title: "Policies Access Restricted",
    message: "You don't have permission to manage policies. Only managers and owners can access this feature."
  },

  // Settings
  SETTINGS: {
    title: "Settings Access Restricted",
    message: "You don't have permission to access settings. Only business owners can access this feature."
  },

  // Generic messages
  GENERIC: {
    title: "Access Restricted",
    message: "You don't have permission to access this feature."
  },

  PAGE_ACCESS: {
    title: "Page Access Restricted",
    message: "You don't have permission to access this page."
  }
};

/**
 * Get permission message for a specific feature
 * @param {string} feature - The feature key
 * @returns {Object} Permission message object with title and message
 */
export const getPermissionMessage = (feature) => {
  return PERMISSION_MESSAGES[feature] || PERMISSION_MESSAGES.GENERIC;
};

/**
 * Get permission message for a specific permission key
 * @param {string} permissionKey - The permission key
 * @returns {Object} Permission message object with title and message
 */
export const getPermissionMessageByKey = (permissionKey) => {
  const permissionFeatureMap = {
    'manage_services': 'SERVICE_TYPES',
    'manage_staff': 'TEAM_MEMBERS',
    'edit_profile': 'BUSINESS_PROFILE',
    'view_analytics': 'ANALYTICS',
    'view_financials': 'FINANCIALS',
    'manage_financials': 'FINANCIALS',
    'manage_portfolio': 'PORTFOLIO',
    'manage_policies': 'POLICIES'
  };

  const feature = permissionFeatureMap[permissionKey];
  return getPermissionMessage(feature);
};





























